import { useDialog } from "@platform/store";
import { useFetchFeaturedOrganizations } from "@core/features/organization";
import { marketingContentData } from "./marketingContent.data";
import { MarketingContent } from "./MarketingContent";

export function MarketingContentContainer() {
  const handleDonateClick = () => {
    window.open(
      "https://www.every.org/outlast-foundation/f/pollinator",
      "_blank"
    );
  };

  const { openDialog } = useDialog();
  const { data: featuredOrganizations = [] } =
    useFetchFeaturedOrganizations();

  return (
    <MarketingContent
      sectionsContent={marketingContentData}
      featuredOrganizations={featuredOrganizations}
      onAddYourInstitutions={() => openDialog("addYourInstitution")}
      onHireUsClick={() => openDialog("hireUs")}
      onNewsletterClick={() => openDialog("newsletter")}
      onDonateClick={handleDonateClick}
    />
  );
}

export default MarketingContentContainer;

